export enum StorageType {
    ambulance = 'ambulance',
    hospital = 'hospital',
    storage = 'storage',
}
